import {state} from './state.js';

export const UPDATE_ID = (State, id) => {
    State.currentId = parseInt(id)
}
export const SET_LOAD = (State, data) => {
    State.loadMap = data;
};


// WEBPACK FOOTER //
// ./src/store/mutations.js